import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import { BookParams, StoreTypename } from '@monorepo/shared/src/types';
import { Book } from '../../../graph/schema-generated-types-educator';
import GET_BOOK from '../../queries/books/get-book-query';

export type BookStoreState = {
  book: Book | Record<string, any>;
  error: ApolloError | undefined;
  isLoading: boolean;
};

export type BookStore = [BookStoreState, Record<string, any>];

export const getDefaultBookContentStoreState = (): { __typename: string } => ({
  __typename: StoreTypename.BOOK,
});

const useBookStore = (bookParams: BookParams): BookStore => {
  const { data, loading, error }: QueryResult<{ book: Book }> = useQuery(GET_BOOK, {
    variables: {
      bookWhere: {
        bookCode: bookParams.bookCode,
        type: bookParams.bookType,
        edition: 2022,
        character: {
          character: bookParams.letter,
          characterCase: 'UPPERCASE',
          characterType: 'PRINT',
        },
      },
    },
  });

  return [
    {
      book: data?.book || {},
      error,
      isLoading: loading,
    },
    {},
  ];
};

export default useBookStore;
